import { z } from 'zod';
export const arnRoleValidator = (invalidError) => z
    .string()
    .regex(/^arn:(aws|aws-us-gov|aws-cn):iam::\d{12}(?:|:role\/[\w+,./=@-]{1,64})$/, invalidError);
